module.exports = __webpack_public_path__ + "static/media/Annexe_S_ radiologie.9344904b.pdf";